/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react"
import styles from "ui/feature/piece-play/simplified-note-by-note/SimplifiedNoteByNotePlayerFinished.module.scss";
import Header2 from "ui/kit/typography/Header2";
import Button from "ui/kit/buttons/Button";

interface Props {
    restart: () => void
}

const SimplifiedNoteByNotePlayerFinished: React.FC<Props> = ({restart}) => {

    return (
        <div className={styles.background}>
            <div className={styles.contentContainer}>
                <Header2>You are finished. What would you like to do now?</Header2>
                <Button title={"Restart"} onClick={restart}/>
            </div>
        </div>
    );
}

export default SimplifiedNoteByNotePlayerFinished;